import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { myId, formatDate } from "../../lib/MyLibrary";
import axios from "axios";
import { proxyServer } from "../../assets/constantes";

const ShowDataAptos = ({ data, emailUser, myFontSize }) => {
  const [dataClient, setDataClient] = useState([]);
  const [phoneUser, setPhoneUser] = useState(null);
  
  const { GetCustomerResult } = data;
  useEffect(() => {
    

    if (GetCustomerResult){
      //consultar el phoneUser
      getPhoneUser(GetCustomerResult.Number);

      const objDataArray =[
        [ 'idAptos:', GetCustomerResult.Number||'null'],
        [ 'email:', emailUser||'null'],
        [ 'Nombre:', GetCustomerResult.FirstName||'null'],
        [ 'Apellidos:', GetCustomerResult.LastName||'null'],
        [ 'Fecha de Nacimiento:', formatDate(new Date(GetCustomerResult.BirthDate))||'null'],
        [ 'Genero:', GetCustomerResult.Gender||'null'],
        [ 'Estado Civil:', GetCustomerResult.MaritalStatus||'null'],
        [ 'Teléfono:', phoneUser||'null'],
        [ 'Clave Alfanumérica:', GetCustomerResult.AlphaKey||'null'],
        [ 'Fecha de Creación:',formatDate(new Date(GetCustomerResult.CreateDate))||'null'],
        [ 'Tienda Creadora:',GetCustomerResult.CreateStoreNumber||'null'],
        [ 'Usuario Creador:',GetCustomerResult.CreateUser||'null'],
        [ 'Vendedor Asociado:', GetCustomerResult.SalesAssociateNumber||'null']
      ] 
      setDataClient(objDataArray);
    } else setDataClient(null);
    
    
    
    return;
  }, []);

  //renderizar cuando se tenga el phoneUser
  useEffect(() => {
    if (phoneUser) {
      const objDataArray =[
        [ 'idAptos:', GetCustomerResult.Number||'null'],
        [ 'email:', emailUser||'null'],
        [ 'Nombre:', GetCustomerResult.FirstName||'null'],
        [ 'Apellidos:', GetCustomerResult.LastName||'null'],
        [ 'Fecha de Nacimiento:', formatDate(new Date(GetCustomerResult.BirthDate))||'null'],
        [ 'Genero:', GetCustomerResult.Gender||'null'],
        [ 'Estado Civil:', GetCustomerResult.MaritalStatus||'null'],
        [ 'Teléfono:', phoneUser||'null'],
        [ 'Clave Alfanumérica:', GetCustomerResult.AlphaKey||'null'],
        [ 'Fecha de Creación:',formatDate(new Date(GetCustomerResult.CreateDate))||'null'],
        [ 'Tienda Creadora:',GetCustomerResult.CreateStoreNumber||'null'],
        [ 'Usuario Creador:',GetCustomerResult.CreateUser||'null'],
        [ 'Vendedor Asociado:', GetCustomerResult.SalesAssociateNumber||'null']
      ] 
      setDataClient(objDataArray);
    } else setDataClient(null);
  }, [phoneUser]);

  const getPhoneUser = async (idAptos) => {
    try {
      const resPhoneUser = await axios.get(
        `${proxyServer}api/getCustomerPhonesByIdAptos/${idAptos}`
      );
      const { result } = resPhoneUser.data;
      if (result?.phoneUser) {
        console.log("result.phoneUser:..", result.phoneUser);
        setPhoneUser(result.phoneUser);
      } else setPhoneUser(null);
    } catch (error) {
      console.log("Error getPhoneUser:..", error);
    }
  }
  
  return (
    <div>
      <Container fluid style={{width: "90%"}} className="border border-2 bg-light p-3 rounded">
        {dataClient && dataClient.map(item=>{
          return <p key={myId()} style={{ width: "90%" }} className="text-secondary fs-6 my-0 ms-auto me-auto">
          <span style={{ width: "40%", fontSize: myFontSize }} className="border border-2 d-inline-block ps-2 pt-1">{item[0]}</span>
          <span style={{ width: "60%", fontSize: myFontSize }} className="border border-2 text-danger d-inline-block ps-2 pt-1">{item[1]}</span>
        </p>
        })}
      </Container>
    </div>
  );
};

export default ShowDataAptos;
